import BackButtonToolbar from "features/BackButtonToolbar";
import React from "react";
import {
  ArrayField,
  Datagrid,
  FunctionField,
  Labeled,
  ReferenceField,
  Show,
  SimpleShowLayout,
  TextField,
} from "react-admin";
import { Grid, useMediaQuery } from "@mui/material";
import { settings } from "app";
import { administrationRequests } from "api/administrationApi";
import { graduationRequests } from "api/graduationApi";
import RoomField from "server/components/Fields/RoomField";
import { InternshipSessionField } from "server/components/Fields/InternshipSessionInput";
import { SectionTitle } from "features/SectionTitle";

const ShowScheduleIndividualSlot = () => {
  const isMobile = useMediaQuery(theme => theme.breakpoints.down("md"));

  return (
    <Show
      title="Детайли на индивидуално разписание"
      actions={<BackButtonToolbar />}
    >
      <SimpleShowLayout>
        <SectionTitle
          title="Информация"
          textAlign="center"
          sx={{ marginTop: "2rem" }}
        />
        <Grid
          container
          spacing={3}
          sx={isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox}
        >
          <Grid
            item
            xs={12}
            md={3}
          >
            <Labeled label="Сесиен стаж">
              <InternshipSessionField />
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={3}
          >
            <Labeled label="Стажантски план">
              <ReferenceField
                source="planId"
                reference={graduationRequests.getInternshipPlansSelect()}
              >
                <TextField source="name" />
              </ReferenceField>
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={3}
          >
            <Labeled label="Дисциплина">
              <ReferenceField
                source="disciplineId"
                reference={administrationRequests.getDisciplinesSelect()}
              >
                <TextField source="name" />
              </ReferenceField>
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={3}
          >
            <Labeled label="Зала">
              <RoomField />
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={3}
          >
            <Labeled label="Бокс номер">
              <TextField source="boxNumber" />
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={6}
          >
            <ArrayField
              source="timeIntervals"
              label="Часови интервали"
            >
              <Datagrid
                rowClick={false}
                bulkActionButtons={false}
                sx={settings.style.secondaryDatagrid}
              >
                <FunctionField
                  label="Час"
                  render={rec => `${rec.from} - ${rec.to}`}
                />
                <ReferenceField
                  source="dateType"
                  reference={graduationRequests.getScheduleDateTypeSelect()}
                  label="Тип дата"
                  sortable={false}
                >
                  <TextField source="nameBg" />
                </ReferenceField>
              </Datagrid>
            </ArrayField>
          </Grid>
        </Grid>
      </SimpleShowLayout>
    </Show>
  );
};

export default ShowScheduleIndividualSlot;
